import { render, staticRenderFns } from "./Alumni.vue?vue&type=template&id=519f7f6d&scoped=true"
import script from "./Alumni.vue?vue&type=script&lang=js"
export * from "./Alumni.vue?vue&type=script&lang=js"
import style0 from "./css/alumni.css?vue&type=style&index=0&id=519f7f6d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f7f6d",
  null
  
)

export default component.exports